import Email from "@material-ui/icons/EmailOutlined";
import "../../pages/Home/Home.css";

export default function SmHeader() {
  return (
    <div className="sm-header">
      <p className="need-help-p">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>Need help?</span>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>
          <Email className="email-icon" />
          &nbsp;&nbsp;&nbsp;&nbsp; contact.skidesign@gmail.com
        </span>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>
          <img src="/Images/phone-icon.png" alt="Telephone" />
          &nbsp;&nbsp;&nbsp;&nbsp; +250780178459
        </span>
      </p>
    </div>
  );
}
